import { render } from "./Main.vue?vue&type=template&id=2e575e84&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=2e575e84&scoped=true&lang=css"
import "./Main.vue?vue&type=style&index=1&id=2e575e84&lang=css"
script.render = render
script.__scopeId = "data-v-2e575e84"

export default script